export function updateFormsState(state, payload) {
    state[payload.state] = payload.data;
  }
  